import { render, staticRenderFns } from "./RecommendDialog.vue?vue&type=template&id=35a23f00&scoped=true&"
import script from "./RecommendDialog.vue?vue&type=script&lang=js&"
export * from "./RecommendDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecommendDialog.vue?vue&type=style&index=0&id=35a23f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a23f00",
  null
  
)

export default component.exports